import React from 'react';
import styles from './EventPhotos.module.css';

const EventPhotos: React.FC = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.imageWrapper}>
          <img
            src="/assets/images/event-photo.jpg"
            alt="Retour sur le dernier évènement B2B"
            className={styles.image}
          />
        </div>
        <div className={styles.content}>
          <h2 className={styles.title}>
            Retour SUR le dernier évènement B2B
          </h2>
          <p className={styles.text}>
            Le tout premier opus de Brands2Buyers a eu lieu le 6 février dernier !
            Revivez ces moments à travers notre galerie photos.
          </p>
          <a href="https://photos.app.goo.gl/XE9WoYkmg5dskVaV6" target="_blank" rel="noopener noreferrer" className={styles.button}>
            VOIR LES PHOTOS
          </a>
        </div>
      </div>
    </section>
  );
};

export default EventPhotos;
